import { Controller } from "@hotwired/stimulus";

const HEIC_MIME_TYPES = new Set(["image/heic", "image/heif"]);

export default class extends Controller {
  static targets = ["preview", "input"];

  preview() {
    const file = this.inputTarget.files[0];
    if (!file) return;

    this.previewTarget.innerHTML = "";
    this.previewTarget.classList.remove("hidden");

    const previewFormat = this.heicPreviewFormat(file);
    if (previewFormat) {
      this.previewTarget.appendChild(this.buildHeicPreviewPlaceholder(file, previewFormat));
      return;
    }

    const reader = new FileReader();
    reader.onload = e => {
      const img = document.createElement("img");
      img.src = e.target.result;
      img.classList.add("object-contain", "max-h-40", "w-full");

      this.previewTarget.appendChild(img);
    };
    reader.readAsDataURL(file);
  }

  buildHeicPreviewPlaceholder(file, format) {
    const placeholder = document.createElement("div");
    placeholder.className = "flex min-h-40 w-full flex-col items-center justify-center gap-1 bg-ec-soft-surface px-4 py-6 text-center";
    placeholder.setAttribute("data-heic-preview-placeholder", "");
    placeholder.setAttribute("role", "status");

    const formatLabel = document.createElement("span");
    formatLabel.className = "rounded-full border border-ec-border bg-ec-page px-3 py-1 text-xs font-semibold text-ec-muted-text";
    formatLabel.textContent = format;

    const selectionCopy = document.createElement("p");
    selectionCopy.className = "mt-2 mb-0 text-sm font-semibold text-ec-text";
    selectionCopy.textContent = `${format} photo selected`;

    const filename = document.createElement("p");
    filename.className = "mb-0 max-w-full break-all text-xs text-ec-muted-text";
    filename.textContent = file.name;

    const previewCopy = document.createElement("p");
    previewCopy.className = "mb-0 text-xs text-ec-muted-text";
    previewCopy.textContent = "Preview available after save.";

    placeholder.appendChild(formatLabel);
    placeholder.appendChild(selectionCopy);
    placeholder.appendChild(filename);
    placeholder.appendChild(previewCopy);

    return placeholder;
  }

  heicPreviewFormat(file) {
    const mimeType = file.type.toLowerCase();
    const extension = file.name.split(".").pop()?.toLowerCase();

    if (extension === "heic") return "HEIC";
    if (extension === "heif") return "HEIF";
    if (mimeType === "image/heif") return "HEIF";
    if (HEIC_MIME_TYPES.has(mimeType)) return "HEIC";

    return null;
  }
}
